import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { isLocalStorageSupported } from './is-local-stroage-supported.function'
import { LocalStorageFallback } from './local-storage-fallback.service'
import { LocalStorageImpl } from './local-storage-impl.service'
import { StorageItemChangeEvent } from './storage-item-change-event.type'

@Injectable({
  providedIn: 'root',
  useFactory: () => {
    // in safari and chrome cookies can be disallowed.
    //   This option also affects the localstorage: when trying to set or get from the LS it will throw
    const support = isLocalStorageSupported()
    return support ? new LocalStorageImpl() : new LocalStorageFallback()
  },
})
export abstract class LocalStorage {
  /**
   * Whether the data is actually stored persistently.
   * Basically whether the browser allows the LS usage.
   */
  abstract readonly persistent: boolean

  abstract observe(key: string): Observable<StorageItemChangeEvent>

  abstract setItem(key: string, value: any): void

  abstract getItem(key: string): unknown

  abstract delete(...keys: string[]): void

  abstract clear(): void

  abstract keys(): string[]
}
